import { useTranslation } from 'react-i18next'
import styles from '../User.module.scss'
import { useStoreSelector } from 'hooks/store'
import { Heading } from '@boltenergy-be/design-system'
import dayjs from 'dayjs'
import { DATE_FORMAT } from 'constants/constants'
import Link from 'components/link/Link.tsx'
import { routes } from 'types/routes'
import { UserTypes } from 'store/auth/types'
import classNames from 'classnames'
import { selectCurrentAccount } from 'store/contact/slice.ts'

const Personal = () => {
  // Redux
  const { contact } = useStoreSelector((store) => store.contact)
  const account = useStoreSelector(selectCurrentAccount)
  const { userType } = useStoreSelector((store) => store.auth)

  // i18n
  const { t } = useTranslation(['user', 'validation', 'contracts', 'common', 'support'])

  // Constants
  const birthDate = account.birthDate

  return (
    <section className={styles['table-wrapper']}>
      <div>
        {!!account.company && (
          <Heading as="h2" variant="h5">
            {t(($) => $.personal, {
              ns: 'common'
            })}
          </Heading>
        )}

        <ul className={styles.table}>
          <li>
            <strong>
              {t(($) => $.personal.form.clientNbr, {
                ns: 'user'
              })}
            </strong>
            {account.customerNumber || '—'}
          </li>

          <li>
            <strong>
              {t(($) => $.personal.form.firstName, {
                ns: 'user'
              })}
            </strong>
            {account.firstName || '—'}
          </li>

          <li>
            <strong>
              {t(($) => $.personal.form.lastName, {
                ns: 'user'
              })}
            </strong>
            {account.lastName || '—'}
          </li>

          <li>
            <strong>
              {t(($) => $.personal.form.email, {
                ns: 'user'
              })}
            </strong>
            {contact?.email || '—'}
          </li>

          <li>
            <strong>
              {t(($) => $.personal.form.phone, {
                ns: 'user'
              })}
            </strong>
            {contact?.phone || '—'}
          </li>

          <li>
            <strong>
              {t(($) => $.personal.form.birthDate.title, {
                ns: 'user'
              })}
            </strong>
            {birthDate ? dayjs(birthDate).format(DATE_FORMAT) : '—'}
          </li>
        </ul>
      </div>

      {!!account.company && (
        <div className={styles.company}>
          <Heading as="h2" variant="h5">
            {t(($) => $.add.steps.customerData.sections.company, {
              ns: 'contracts'
            })}
          </Heading>
          <ul className={styles.table}>
            <li>
              <strong>
                {t(($) => $.personal.form.company.name, {
                  ns: 'user'
                })}
              </strong>
              {account.company.name || '—'}
            </li>

            <li>
              <strong>
                {t(($) => $.personal.form.company.legalForm, {
                  ns: 'user'
                })}
              </strong>
              {account.company.legalForm ? t(($) => $.legalForms[account.company!.legalForm], { ns: 'common' }) : '—'}
            </li>

            <li>
              <strong>
                {t(($) => $.personal.form.company.enterpriseNumber, {
                  ns: 'user'
                })}
              </strong>
              {account.company.enterpriseNumber || '—'}
            </li>
          </ul>
        </div>
      )}

      {userType === UserTypes.SUPER_USER ? (
        <Link representation="button" isFullwidthMobile className={styles.edit} variant="secondary" href={routes.USER_EDIT_PERSONAL}>
          {t(($) => $.edit, {
            ns: 'common'
          })}
        </Link>
      ) : (
        <footer className={classNames(styles.footer, 'grid-col-full')}>
          <small>{t(($) => $.support, { ns: 'user' })}</small>
          <Link href={routes.SUPPORT_CONTACT} variant="secondary" size="small">
            {t(($) => $.contact.tab, {
              ns: 'support'
            })}
          </Link>
        </footer>
      )}
    </section>
  )
}

export default Personal
